export const Bio = {
  name: "Vishwakarma",
  roles: [
    "Java Full Stack Developer",
    "Backend Developer",
    "Programmer",
  ],
  description:
    "I am a driven and adaptable individual, always enthusiastic about embracing new challenges. Passionate about continuous learning, I strive to deliver exceptional results. With a proactive mindset and a positive attitude, I’m committed to making valuable contributions and reaching new heights in every opportunity I pursue.",
  github: "https://github.com/vishwa334",
  resume:
    "https://drive.google.com/file/d/1H3mEkrZeLac7RiO9ZA7zUVHmZxNsGBaY/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/vishwa334/",
  twitter: " ",
  insta: "https://www.instagram.com/__vicky___sahani__/",
  facebook: "https://www.facebook.com/vicky.nishad.90857901",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "Tailwind CSS",
        image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg"
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original-wordmark.svg" 
      },
      {
        name: "Spring Boot",
        image:" https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spring/spring-original-wordmark.svg"
          
         },
      
      {
        name: "Spring MVC",
        image:"https://miro.medium.com/v2/resize:fit:1100/format:webp/0*sGeV_-py11DXLF7W.png"
          
     },
       {
        name: "Spring Security",
        image:"https://miro.medium.com/v2/resize:fit:828/format:webp/1*vQ5I4c8inMOoUfGB7BunCQ.png"
          
     },

      {
        name: "Hibernate",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/hibernate/hibernate-original-wordmark.svg"
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "RestApi",
        image: "	https://www.ovhcloud.com/sites/default/files/styles/phablets_1x/public/2022-05/whatis_rest_api.webp ",
      },
      {
        name: "JDBC",
        image: "https://www.openhab.org/logos/jdbc.svg",
      },
       {
        name: "Microservices",
        image: "https://jpmorgenthal.com/wp-content/uploads/2021/01/Microservices.png",
      },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Javascript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Python",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original-wordmark.svg",
      },
      {
        name: "C++",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-plain-wordmark.svg"
       },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg"
           },
      {
        name: "Render",
        image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAAAAADFHGIkAAAAfklEQVR4AWP4jwOgSfzY1D31JhaJU6oMQBDwEl3iiQADGKj+QJMIYICCOlSJlwwwYIoqsYkBDlAl0uHiAigSTzjhEpHIEj+s4eKcF5EknpgibNgE9keddcvq/ZvyOcFKre3t7dNv/odIIFSm/4DoRpcQA/KxSlgPaQlUQFgCABOfchUR/bqdAAAAAElFTkSuQmCC"
            },
      {
        name: "InteliJ IDEA",
        image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/intellij/intellij-original.svg"
         },

      {
        name:"OAuth",
        image:"https://www.varonis.com/hubfs/Imported_Blog_Media/what-is-oauth.png"
      },
      {
        name: "Linux",
        image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/linux/linux-original.svg"
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.northcorpsoftware.com/img/logo.png",
    role: "Java Backend Devloper Intern",
    company: "Northcorp Software pvt ltd",
    date: "jun 2024 - July 2024",
    desc: " Created and optimized RESTful APIs using Spring Boot to enhance backend functionality. Worked with MySQL/PostgreSQL to design and manage database schemas.  Implemented authentication & authorization mechanisms using Spring Security & JWT. Collaborated with frontend developers to integrate APIs and troubleshoot backend issues. Gained hands-on experience in microservices architecture, performance optimization, and debugging.",
    
    skills: [
      "Java",
      "Sprin Boot",
      "SpringMVC",
      "Spring Security",
      "JDBC",
      "MySql",
      "PostgreSql",
      "Servlet",
      "Postman",
      
    ],
    doc: "https://github.com/vishwa334/my_img/blob/main/Screenshot%202025-06-14%20020302.png?raw=true",
  },
  {
    id: 1,
    img: "",
    role: "Java Full Stack Developer Trainee",
    company: "Code for Success Issue By Ashwani Kumar, Senior Software Engineer",
    date: "August 2024 - November 2024",
    desc: "Completed a comprehensive, hands-on training program in full stack development with a strong focus on backend technologies. The course involved building real-time projects and participating in live coding sessions to develop scalable and maintainable web applications. Emphasis was placed on backend architecture, service integration, and preparing for backend and full stack developer roles.",
    skills: [
      "JAVA",
      "JDBC",
      "Servlet",
      "Spring Boot",
      "Spring MVC",
      "Spring Security",
      "Microservices",
      "Docker",
      "Kafka",
      "HTML",
      "CSS",
      "JavaScript",
      "React JS",
    ],
    doc: "https://github.com/vishwa334/my_img/blob/main/Screenshot%202025-06-14%20020503.png?raw=true",
  },
];

export const education = [
  {
    id: 0,
    img: "https://ptu.ac.in/wp-content/themes/cynic/images/classic-logo.png",
    school: "I.K. GUJRAL PUNJAB TECHNICAL UNIVERSITY, JALANDHAR",
    date: "July 2023 - June 2025",
    grade: "Grade: 8.08 CGPA",
    desc: "I have successfully completed my Master of Computer Applications, which equipped me with a strong foundation in software development, data structures, algorithms, database management, and modern technologies like Java, Spring Boot, React, and web development frameworks. During this program, I worked on multiple real-world projects that enhanced my problem-solving skills and deepened my understanding of full-stack development. This academic journey has prepared me to contribute effectively in professional software development environments.",
    degree: "Master of Computer Application - MCA, Computer Application",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/0/0f/Babasaheb_Bhimrao_Ambedkar_Bihar_University_logo.png",
    school: "Babasaheb Bhimrao Ambedkar Bihar University, Muzaffarpur",
    date: "Apr 2019 - Apr 2023",
    grade: "Grade: 76%",
    desc: "I completed my Bachelor of Computer Applications from Babasaheb Bhimrao Ambedkar Bihar University, Muzaffarpur between April 2019 and April 2023. This program provided a strong foundation in core areas such as programming in C/C++, Java, database management systems, computer networks, and web development technologies like HTML, CSS, and JavaScript. During the course, I worked on several academic projects that enhanced my logical thinking, problem-solving skills, and interest in full-stack development. This degree laid the essential groundwork for my advanced studies and a future in the software industry.",
    degree: "Bachelor of Computer Application-BCA, Computer Application",
  },
  {
    id: 2,
    img: "https://images.shiksha.com/mediadata/images/1664428615phpfqJPix.jpeg",
    school: "Jamunilal College, Hajipur",
    date: "Apr 2017 - Apr 2019",
    grade: "",
    desc: "",
    degree: "Isc., Science with Mathematics",
  },
   {
    id: 3,
    img: "",
    school: "Aadarsh Yuvak High School, Barua",
    date: "March 2015 - Apr 2017",
    grade: "",
    desc: "",
    degree: "Matriculation",
  },
];

export const projects = [

  {
    id: 4,
    title: "My Portfolio",
    date: "March 2025",
    description:
      "he Personal Portfolio Website is a responsive and visually appealing web application designed to showcase my skills, projects, certifications, and experience as a Java Full Stack Developer. It serves as an interactive resume, helping recruiters and collaborators learn more about my background and work.",
    image:
      "https://github.com/vishwa334/my_img/blob/main/Screenshot%202025-06-14%20015639.png?raw=true",
    tags: ["React JS",
       "Tailwind CSS", 
       "Material UI",
        "JavaScript",
        "GitHub Pages",
        "Responsive Design",
       "Google Drive Cloud API"],
    category: "web app",
    github: "https://github.com/vishwa334/My-Portfolio",
    webapp: "https://my-portfolio-k4ml.onrender.com/",
    member: [
      {
        name: "Vishwakarma kumar",
        img: "https://github.com/vishwa334/my_img/blob/main/myimg.png?raw=true",
        linkedin: "https://www.linkedin.com/in/vishwa334/",
        github: "https://github.com/vishwa334/",
      },
      
    ],
  },
  {
    id: 0,
    title: "Smart Contact Manager",
    date: "Jun 2024 - Jul 2024",
    description:
      "The Smart Contact Manager is a secure and user-friendly web application designed to manage personal and professional contacts efficiently. The application allows users to register, log in securely, and perform CRUD (Create, Read, Update, Delete) operations on their contacts. Each contact can include personal details like name, email, phone number, and description, along with an optional profile image.",
    image:
      "https://github.com/vishwa334/contactmanager/blob/master/src/main/resources/static/images/Screenshot%202025-06-13%20215522.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "Tailwind CSS",
      "Bootstrap",
      "Java",
      "Spring Boot",
      "PostgreSQL",
      "OAuth2.0",
      "Spring Security",
      "Thymleaf",
    ],
    category: "web app",
    github: "https://github.com/vishwa334/contactmanager",
    webapp: "https://contactmanager-t36e.onrender.com",
    member: [
      {
        name: "Vishwakarma kumar",
        img: "https://github.com/vishwa334/my_img/blob/main/myimg.png?raw=true",
        linkedin: "https://www.linkedin.com/in/vishwa334/",
        github: "https://github.com/vishwa334/",
      },
      
    ],
  },
  {
    id: 1,
    title: "E-commerce Application",
    date: "August 2024 - September 2024",
    description:
      "The E-commerce Web Application is a full-stack project developed to simulate a real-world online shopping experience. It allows users to browse products, add items to the cart, and place orders securely. The system includes both user and admin roles, providing complete control over the platform’s functionalities.",
    image:
      "https://github.com/vishwa334/ecommerce-repo/blob/main/src/main/resources/static/img/Screenshot%202025-06-14%20000527.png?raw=true",
    tags: ["HTML",
       "CSS", 
       "JavaScript", 
       "Bootstrap",
        "Java",
        "Spring Boot",
        "PostgreSQL",
        "Thymleaf",
        "Spring MVC",
      
      ],
    category: "web app",
    github: "https://github.com/vishwa334/ecommerce-repo",
    webapp: "https://github.com/vishwa334/ecommerce-repo",
    member: [
      {
        name: "Vishwakarma kumar",
        img: "https://github.com/vishwa334/my_img/blob/main/myimg.png?raw=true",
        linkedin: "https://www.linkedin.com/in/vishwa334/",
        github: "https://github.com/vishwa334/",
      },
      
    ],
  },
  {
    id: 2,
    title: "Library Management System",
    date: "January 2023",
    description:
      "The Library Management System is a robust web-based application designed to streamline the day-to-day operations of a library. It allows administrators to manage books, track issued/returned books, and maintain student records, while users can search for available books and view their borrowing history.",
    image:
      "https://github.com/vishwa334/library_management/blob/main/Screenshot%202025-06-13%20231918.png?raw=true",
    tags: [
      "Core java",
      "Java Swing",
      "JDBC",
      "Applet",
      "Apache Tomcat",
      "MySQL",
    ],
    category: "desktop app",
    github: "https://github.com/vishwa334/library_management",
    webapp: "https://github.com/vishwa334/library_management",
    member: [
      {
        name: "Vishwakarma kumar",
        img: "https://github.com/vishwa334/my_img/blob/main/myimg.png?raw=true",
        linkedin: "https://www.linkedin.com/in/vishwa334/",
        github: "https://github.com/vishwa334/",
      },
      
    ],
  },
  {
    id: 3,
    title: "Quiz Application",
    date: "Jan 2025- feb 2025",
    description:
      "Quiz Master is a full-stack web application designed to streamline online assessments and quiz management for educational institutions. It provides role-based access for Admin, Teacher, and Student, each with distinct functionalities to ensure a secure and efficient quiz system.",
    image:
      "https://github.com/vishwa334/quiz_master/blob/main/quiz-master-frontend/public/images/Screenshot%202025-06-14%20002611.png?raw=true",
    tags: ["React JS",
       "Tailwind CSS",
        "Material UI",
         "Java",
           "Spring Boot",
           "PostgreSQL",
           "Spring MVC",
           ],
    category: "web app",
    github: "https://github.com/vishwa334/quiz_master",
    webapp: "https://github.com/vishwa334/quiz_master",
    member: [
      {
        name: "Vishwakarma kumar",
        img: "https://github.com/vishwa334/my_img/blob/main/myimg.png?raw=true",
        linkedin: "https://www.linkedin.com/in/vishwa334/",
        github: "https://github.com/vishwa334/",
      },
      
    ],
  },
  
 
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
